import React, { useEffect, useRef } from 'react'
import './css/sampleGraph.css'
import './css/GraphContentsHover.css'
import Lottie from "lottie-react";
// import graphIcon from './images/ViewDashboard/line-chart.png'
// import circle from './images/ViewDashboard/dry-clean.png'
import selectAnimate from './images/ViewDashboard/selectAnimate.json'

function  GraphContentsHover({datas}) {
  
  // const animationContainer = useRef(null);

    // useEffect(() => {
    //     lottie.loadAnimation({
    //         container: animationContainer.current,
    //         renderer: 'svg',
    //         loop: true,
    //         autoplay: true,
    //         animationData: selectAnimate,
    //     });
    // }, [selectAnimate]);
    // const defaultOptions = {
    //   loop: true,
    //   autoplay: true,
    //   animationData: selectAnimate,
    // };

  const months = [
    { value: 'Jan', label: 'January' },
    { value: 'Feb', label: 'February' },
    { value: 'Mar', label: 'March' },
    { value: 'Apr', label: 'April' },
    { value: 'May', label: 'May' },
    { value: 'Jun', label: 'June' },
    { value: 'Jul', label: 'July' },
    { value: 'Aug', label: 'August' },
    { value: 'Sep', label: 'September' },
    { value: 'Oct', label: 'October' },
    { value: 'Nov', label: 'November' },
    { value: 'Dec', label: 'December' }
  ]

  // Function to find full month name
  const getFullMonthName = (monthAbbreviation) => {
    // // //(monthAbbreviation);
    const monthObj = months.find(month => month.value === (monthAbbreviation.value ? monthAbbreviation.value : monthAbbreviation));
    return monthObj ? monthObj.label : '';
  };

  return (
    <div className="w-1/4 p-1 bg-[#fff] shadow-[0px_0px_15px_rgba(0,0,0,0.1)] rounded-md">
      {datas ? (
        <div className='Div_hover_Month_Container'>
          <p className='Div_hover_Month'>{getFullMonthName(datas.month)}&nbsp;{datas.day}</p>
          <p>{datas.text} : {datas.value}</p>
        </div>
      ) : (
        <div className='AnimationDiv_Container'>
          <div className='AnimationDiv'>
            {/* <div className='graphIconImg' ref={animationContainer}></div> */}
            <Lottie animationData={selectAnimate} loop={true} className='Lottie'/>
            {/* <img className='graphIconImg' src={graphIcon} alt="" /> */}
            <div className='graphIconCircleDiv'>
              <div className='graphIconCircle'></div>&nbsp;
              view sales details
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default GraphContentsHover;
